import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const CheckedIcon: React.FC<SvgIconDefaultProps> = ({ className, testId }) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <path
        d="M17 2.83334C9.19421 2.83334 2.83337 9.19417 2.83337 17C2.83337 24.8058 9.19421 31.1667 17 31.1667C24.8059 31.1667 31.1667 24.8058 31.1667 17C31.1667 9.19417 24.8059 2.83334 17 2.83334ZM23.7717 13.7417L15.7392 21.7742C15.5409 21.9725 15.2717 22.0858 14.9884 22.0858C14.705 22.0858 14.4359 21.9725 14.2375 21.7742L10.2284 17.765C9.81754 17.3542 9.81754 16.6742 10.2284 16.2633C10.6392 15.8525 11.3192 15.8525 11.73 16.2633L14.9884 19.5217L22.27 12.24C22.6809 11.8292 23.3609 11.8292 23.7717 12.24C24.1825 12.6508 24.1825 13.3167 23.7717 13.7417Z"
        fill="#3B9F17"
      />
    </CustomSvg>
  );
};
export default CheckedIcon;
